import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import classes from "./styles/style.module.css";
import { setShowWordGameHintModal } from "../../../assets/redux/actions/Quiz";
import WordGameHintDialog from "../alertContents/WordGameHintDialog";
import { useNavigate, useParams } from "react-router-dom";
import {
  createWordGameTicketV2,
  getWordGameEventById,
} from "../../../assets/services/apiServices";
import errorHandler from "../../../assets/utils/ErrorHandler";
import Loading from "../../../assets/containers/loadingDialog";
import { baseURL } from "../../../assets/constants/baseUrl";

const WordGamePreview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [eventData, setEventData] = useState(null);
  const [loadingGetData, setloadingGetData] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEventData();
  }, []);

  const fetchEventData = async () => {
    try {
      const response = await getWordGameEventById(id);
      setEventData(response.data.wordGameEvent);
    } catch (err) {
      errorHandler(err);
    } finally {
      setloadingGetData(false);
    }
  };

  const handleStartGame = async () => {
    setLoading(true);
    try {
      const response = await createWordGameTicketV2(eventData._id);
      const matchId = response.data.createdTicket._id;
      navigate(`/wordGame/${matchId}`);
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  if (loadingGetData) {
    return (
      <div className="customContainer d-flex justify-content-center align-items-center vh-100">
        <Loading />
      </div>
    );
  }

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        {eventData && (
          <p className={classes.WordGameTitle}>
            {eventData.title}
          </p>
        )}
        {eventData?.subtitle && (
          <p className={classes.WordGameSubTitle}>{eventData.subtitle}</p>
        )}
        {eventData?.poster ? (
          <img
            src={`${baseURL}file/get/${eventData.poster}`}
            className="img-fluid w-100 mt-2 mb-3"
            alt="wordGamePreview"
          />
        ) : (
          <img
            src="/images/wordGame/wordGamePoster.png"
            className="img-fluid w-100 mt-2 mb-3"
            alt="wordGamePreview"
          />
        )}
        {eventData?.description && (
          <div className={classes.descriptionContainer} dangerouslySetInnerHTML={{__html:eventData.description}}></div>
        )}

        <div className="mt-4">
          {!loading ? (
            <button
              className={`${classes.wordGameButton} ${classes.purplueButton}`}
              onClick={handleStartGame}
            >
              شروع چالش
            </button>
          ) : (
            <div className="d-flex justify-content-center">
              <Loading />
            </div>
          )}
          <br />
          <br />
          <button
            className={`${classes.wordGameButton} ${classes.greenButton}`}
            onClick={() => dispatch(setShowWordGameHintModal(true))}
          >
            راهنمایی
          </button>
        </div>
      </div>
      <WordGameHintDialog />
    </AnimatedPageContainer>
  );
};

export default WordGamePreview;
